module.exports = __webpack_public_path__ + "img/30x30_gri.251475f8.gif";